module.exports = __webpack_public_path__ + "img/shame.8989b994.svg";